<script>
export default {
    data() {
        return {
            downloadAttachment: false,
            exportAllToExcel: false,
            exportFilterToExcel: false,
            deleteSettings: false,
            deleteAttachment: false
        }
    },
    computed: {
        myPermissions() {
            return this.$store.getters['auth/getUserPermissions']
        },
    },
    methods: {
        checkPermissions() {
            this.myPermissions.forEach(permission => {
                if (permission.permission.permissionCode === 'Action-ViewAttachments') {
                    if (permission.permissionLevel === 1) {
                        this.downloadAttachment = true
                    } else {
                        this.downloadAttachment = false
                    }
                }
                if (permission.permission.permissionCode === 'Action-ExportAllToExcel') {
                    if (permission.permissionLevel === 1) {
                        this.exportAllToExcel = true
                    } else {
                        this.exportAllToExcel = false
                    }
                }
                if (permission.permission.permissionCode === 'Action-ExportFilteredDataToExcel') {
                    if (permission.permissionLevel === 1) {
                        this.exportFilterToExcel = true
                    } else {
                        this.exportFilterToExcel = false
                    }
                }
                if (permission.permission.permissionCode === 'DeleteSettings') {
                    if (permission.permissionLevel === 1) {
                        this.deleteSettings = true
                    } else {
                        this.deleteSettings = false
                    }
                }
                if (permission.permission.permissionCode === 'DeleteAttachment') {
                    if (permission.permissionLevel === 1) {
                        this.deleteAttachment = true
                    } else {
                        this.deleteAttachment = false
                    }
                }
            })
        }
    }
}
</script>